export default {
  namespaced: true,
  state: {
    showMenuModalFlag: false,
    menuModalFlagOpenedFrom:"",
    stopHorizontalScrollAnchorLinks:false,
    clickedCategoryAnchorLink:"",
    stopHorizontalScrollAnchorLinksFilterClick:false,
    selectedMenuCategory:{
      id:"",
      category:""
    },
    tagImageInfoObj:{}
  },
  getters: {
    getSelectedMenuCategory: (state) => {
      return state.selectedMenuCategory;
    },
  },
  mutations: {
    updateNewMenuModalFlag(state, payload) {
      state.showMenuModalFlag= payload;
    },
    updateMenuModalFlagOpenedFrom(state,payload){
      state.menuModalFlagOpenedFrom=payload;
    },
    updateStopHorizontalScrollAnchorLinks(state,payload){
      state.stopHorizontalScrollAnchorLinks=payload;
    },
    updateClickedCategoryAnchorLink(state,payload){
      state.clickedCategoryAnchorLink=payload;
    },
    updateStopHorizontalScrollAnchorLinksFilterClick(state,payload){
      state.stopHorizontalScrollAnchorLinksFilterClick = payload;
    },
    updateSelectedMenuCategory(state,payload){
      state.selectedMenuCategory = payload;
    },
    updateTagImageInfoObj(state,payload){
      state.tagImageInfoObj = {
        ...state.tagImageInfoObj,
        ...payload
      };
    },
  },
  actions: {
  },
};
